userlinkingController.$inject = ['$state', '$window', 'AuthenticationService'];
export default function userlinkingController($state, $window, AuthenticationService) {
    var ctrl = this;

    ctrl.$onInit = function() {
        AuthenticationService.getProfile(function(err, profile) {
            if (err) {
                console.log(err.message || err);
            } else {
                ctrl.profile = angular.copy(profile);
            }
        });
    };

    ctrl.reload = function() {
        $state.go($state.current, {}, {reload: true});
    };

    ctrl.logout = function() {
        console.log('logout()');
        var self = this;
        AuthenticationService.logout(function(result) {
            if (result === true) {
                $state.go('login');
            } else {
                self.error = __("logout failed");
            }
        });
    };

    ctrl.logout_portal = function() {
        console.log('logout_portal()');
        $window.location.href = '/api/v1/auth/portal/logout0';
    };

}
